import { WeekdayFC } from "@vierkant-software/types__api";
import { CalendarTypeView, DateFormat } from "./datePicker.base.component";
import { Globals } from "src/app/services/globals.service";
import { Validate } from "../util";
import { BaseConfig } from "../config.interface";

interface IDatePickerConfig {
    label?: string;
    format?: DateFormat;
    bufferFormat?: DateFormat;
    view?: CalendarTypeView;
    disabledDays?: WeekdayFC[];
    showClear?: boolean;
    showTime?: boolean;
    showWeek?: boolean;
    showToday?: boolean;
    timeOnly?: boolean;
    display?: 'input' | 'label' | 'inline';
    validate: Validate;
}
export class DatePickerConfig extends BaseConfig<IDatePickerConfig> implements IDatePickerConfig {
    /**
     * Label of the element.
     */
    label?: string;
    /**
     * Date format of the displayed value.
     */
    format?: DateFormat;
    /**
     * Date format of the buffer value when writing the value.
     */
    bufferFormat?: DateFormat;

    /**
     * View of the element.
     * @values "date" | "month" | "year"
     */
    view?: CalendarTypeView;
    /**
     * Disable specific days of the week.
     */
    disabledDays?: WeekdayFC[];
    /**
     * Show clear button.
     */
    showClear?: boolean;
    showTime?: boolean;
    timeOnly?: boolean;
    /**
     * Show week number of the year.
     */
    showWeek?: boolean;
    /**
     * Show today button.
     */
    showToday?: boolean;
    /**
     * Display the element as either an input-element or a label
     */
    display?: 'input' | 'label' | 'inline';
    /**
     * Show validation status already in `pristine` state or after it has been marked as `dirty`.
     */
    validate: Validate;

    /**
     * @theme Base
     */
    static baseTheme = {
        /**
         * Default configuration.
         */
        Default: new DatePickerConfig({
            view:      'date',
            display:   'input',
            showClear: true,
            validate:  "dirty",
        }),

        DateTime: new DatePickerConfig({
            view:      'date',
            showTime:  true,
            display:   'input',
            showClear: true,
            validate:  "dirty",
        }),

        TimeOnly: new DatePickerConfig({
            view:      'date',
            showTime:  true,
            display:   'input',
            timeOnly:  true,
            showClear: true,
            validate:  "dirty",
        }),

        /**
         * Display input element as label.
         * 
         */
        AsLabel: new DatePickerConfig({
            view:      'date',
            display:   "label",
            showClear: false,
            validate:  "dirty",
        }),

        /**
         * Limit selection to working days
         */
        OnlyWorkingDay: new DatePickerConfig({
            view:         'date',
            display:      'input',
            showClear:    true,
            validate:     "dirty",
            disabledDays: [WeekdayFC.Saturady, WeekdayFC.Sunday],
        }),

        /**
         * Select the week of the year.
         */
        Week: new DatePickerConfig({
            view:      "date",
            display:   'input',
            showClear: true,
            validate:  "dirty",
            showWeek:  true,
            format:    "'KW'W  kkkk",
        }),

        /**
         * Date input without year.
         */
        NoYear: new DatePickerConfig({
            view:      'date',
            display:   'input',
            showClear: true,
            validate:  "dirty",
            format:    Globals.DateTime.DATE_NO_YEAR,
        }),

        /**
         * Date input without year and Pristine validation.
         */
        NoYearPristine: new DatePickerConfig({
            view:      'date',
            display:   'input',
            showClear: true,
            validate:  "pristine",
            format:    Globals.DateTime.DATE_NO_YEAR,
        }),

        Appointment: new DatePickerConfig({
            view:      'date',
            display:   'inline',
            showClear: false,
            showWeek:  true,
            showToday: false,
            validate:  "dirty",
        }),
    };

}